import React, { useEffect, useState } from "react";
import { getPaymentTypes } from "../../utils/dataFetch";
import BarGraphHorizontal from "../svg-graphs/BarGraphHorizontal";

export default function PaymentTypes({ startDate, endDate }) {
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchPaymentTypes = async () => {
            try {
                let tempStart = new Date(endDate);
                if (startDate) {
                    tempStart = new Date(startDate);
                }
                tempStart.setHours(0, 0, 0, 0);
                const tempEnd = new Date(endDate);
                tempEnd.setHours(23, 59, 59, 999);
                const result = await getPaymentTypes(
                    tempStart.toISOString(),
                    tempEnd.toISOString()
                );
                setPaymentTypes(result);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };

        fetchPaymentTypes(startDate, endDate);
    }, [endDate, startDate]);

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                <h5 className="text-center fw-bold">Види оплат</h5>
                {error && (
                    <div className="alert alert-danger m-auto rounded-5">
                        {error}
                    </div>
                )}
                {!error &&
                    (paymentTypes.length > 0 ? (
                        <BarGraphHorizontal inputData={paymentTypes} />
                    ) : (
                        <h5 className="text-center mt-3">Дані відсутні!</h5>
                    ))}
            </div>
        </div>
    );
}
